import React from 'react';
import { Grid, Paper, Typography, Button } from '@material-ui/core';

function Progress({ step, onNext, onBack, maxSteps = 3 }) {
  return (
    <Paper
      elevation={2}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        padding: '16px 24px',
        width: '100%',
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography align="left">
            {step > 0 && (
              <Button
                color="primary"
                variant="outlined"
                onClick={onBack}
              >
                Voltar
              </Button>
            )}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right">
            {step < maxSteps && (
              <Button
                color="primary"
                variant="contained"
                onClick={onNext}
              >
                {step === maxSteps - 1 ? 'Finalizar' : 'Prosseguir'}
              </Button>
            )}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default Progress;
